export type TermsTemplateValues = Record<string, string | undefined>;

const MERGE_TAG_PATTERN = /\[(\w+)\]/g;

export function replaceTemplateValues(
  template: string | undefined | null,
  values: TermsTemplateValues = {}
): string {
  if (!template) {
    return '';
  }

  return template.replace(MERGE_TAG_PATTERN, (_match, tag: string) => values[tag] ?? '');
}
